import { Typography, Grid2, Box } from "@mui/material";
import Styles from "./Mob.module.css"
import pic from "../../../../ui-utils/latestPics/EquityBenefits.svg"
import { useLanguage } from "../../../../Context/LangContext";
import en from "../../../../i18n/English/Trade Invest/benefit.json";
import hi from "../../../../i18n/Hindi/Trade Invest/benefit.json";
import kn from "../../../../i18n/Kannada/Trade Invest/benefit.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/benefit.json";
import ma from "../../../../i18n/Marathi/Trade Invest/benefit.json";
export default function BenefitsMob() {
    const { language } = useLanguage();
    const translations = { en, hi, kn,ma,gu };
    const t = translations[language];
    return (
        <>
            <Box className={Styles.outerBox}>
                <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <h1 className={Styles.heading}>
                        {t.heading}
                    </h1>
                </div>
                <Typography className={Styles.subtxt}>
                    {t.subtxt}
                </Typography>
                <Grid2 className={Styles.picCard}>
                    <img src={pic} alt="equity" className={Styles.pic} />
                </Grid2>

                <Grid2 className={Styles.txtCard}>
                    <Typography className={Styles.innertxt1}>
                        <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                            {t.benefits[0].title}{" "}
                        </span>
                        {t.benefits[0].desc}
                    </Typography>

                    <Typography className={Styles.innertxt1} sx={{ paddingTop: "30px" }}>
                        <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                            {t.benefits[1].title}{" "}
                        </span>
                        {t.benefits[1].desc}
                    </Typography>

                    <Typography className={Styles.innertxt1} sx={{ paddingTop: "30px" }}>
                        <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                            {t.benefits[2].title}{" "}
                        </span>
                        {t.benefits[2].desc}
                    </Typography>

                    <Typography className={Styles.innertxt1} sx={{ paddingTop: "30px" }}>
                        <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                            {t.benefits[3].title}{" "}
                        </span>
                        {t.benefits[3].desc}
                    </Typography>

                    <Typography className={Styles.innertxt1} sx={{ paddingTop: "30px" }}>
                        <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                            {t.benefits[4].title}{" "}
                        </span>
                        {t.benefits[4].desc}
                    </Typography>

                </Grid2>



            </Box>
        </>
    )
}